export default {
  book: {
    title: '訂單確認',
    trainInfo: '車票信息',
    seatPreference: '座位偏好',
    passengerInfo: '乘客信息',
    bookingNotice: '預訂前須知',
    paymentConfirmation: '支付前確認事項',
    soldOut: '售罄',
    tip: '請儘速完成流程，以免座位被預訂。',
    passenger: {
      count: '參加者人數',
      representative: '參加者代表',
      representativeTip: '（只需填一位參加者信息）',
      lastName: '姓氏（請輸入半形英數字）',
      firstName: '名字（請輸入半形英數字）',
      email: '聯絡郵箱（收取訂單信息）'
    }
  },
  bookNotice: {
    seat: {
      title: '座位類型',
      content:
        '當座位或座位數量在同檔的所有選項填滿後, 價格會升檔/調整。元旦、假期等假期, 座位數量將不對散客銷售。'
    },
    ticket: {
      title: '票種類型',
      content:
        '以及本行程表里包含的公共交通工具票價均為成人的普通票價。成人陪同則免費。'
    }
  },
  bookConfirm: {
    paymentInfo: '支付信息',
    paymentConfirmation: {
      description:
        '支付前請再次確認填寫的姓名郵箱等信息是否正確。如有誤或將導致無法使用。',
      warningTitle: '請確認取消政策：',
      warningText: '該商品一旦購買將無法退款。',
      agreementText: '我已確認並同意'
    },
    paymentAmount: {
      total: '合計',
      details: '詳細',
      note: '日幣以外的幣種金額為當前匯率換算的預估金額，與實際扣款金額可能略有差異，僅供參考。'
    }
  },
  bookResult: {
    successMessage: '預約已完成，\n請進入訂單詳情查看出票結果。'
  }
};
